import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@wbk/ui';
import { WebSection } from '@wbk/contentful/api';
import GuideCard from '@/components/guides/GuideCard';
import ScrollTitle from '@/components/ui/ScrollTitle';

type Props = {
  section?: WebSection;
};

const AllGuides = ({ section }: Props) => {
  const { t } = useTranslation(['common']);
  const itemsLength = section?.contentCollection?.items.length || 0;
  const [items, setItems] = useState(section?.contentCollection?.items.slice(0, 4) || []);

  const handleLoadMore = () => {
    const currentLength = items.length;
    const moreItems =
      section?.contentCollection?.items.slice(currentLength, currentLength + 4) || [];
    setItems([...items, ...moreItems]);
  };

  if (!items.length) return null;

  return (
    <div className='container-padding container'>
      <div className='container px-3 xl:px-0'>
        <div className='space-y-6'>
          <ScrollTitle title={section?.title || ''} />

          <div className='grid grid-cols-2 gap-2 md:gap-4 lg:grid-cols-4'>
            {section?.contentCollection?.items.map((item, index) => {
              if (item?.__typename !== 'WebCard') return <div key={index} />;

              return (
                <GuideCard
                  key={item.id}
                  buttonText={item.buttonLabel}
                  title={item?.title}
                  description={item?.subtitle ?? ''}
                  image={item?.image}
                  metaData={item?.description?.split('-')}
                  href={item?.href}
                />
              );
            })}
          </div>
          {itemsLength > items.length && (
            <div className='flex w-full items-center justify-center'>
              <Button
                onClick={handleLoadMore}
                className='rounded-full border border-white bg-transparent transition-all duration-200 hover:bg-white/10'
              >
                {t('loadMore')}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllGuides;
